import React from "react";
import propTypes from "prop-types";
import classNames from "classnames";
import { DefaultPageContainer as PageContainer } from "@layout";
import { HeroBlog, ContentBuilder } from "@organisms";
import { FooterContact, Share, NewsletterSignup } from "@molecules";
import { Container, StickyContainer, Button, Text } from "@atoms";

const BlogPage = ({ data }) => {
  const { hero, content, meta, url } = data;

  return (
    <PageContainer meta={meta}>
      <Container variant="lg" className="mt-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr,360px] gap-8 h-full pb-6">
          <div>
            <HeroBlog {...hero} />
            <ContentBuilder blocks={content} blog />
            <div className="hidden lg:block mt-6 mb-12">
              <Share url={url} />
            </div>
          </div>

          <div>
            <StickyContainer endTrigger="footer" className="space-y-6">
              <Share url={url} />

              <div className="bg-blue rounded-xl">
                <div className="flex flex-col items-center justify-center py-5 px-6">
                  <Text variant="h5" className="text-yellow">Get in Touch</Text>
                  <Text variant="sm" className="text-light-blue my-2 text-center leading-snug">
                    Connect with us to discuss how we can lighten your workload.
                  </Text>
                  <div className="mt-3">
                    <Button to="/contact">Contact Us</Button>
                  </div>
                </div>
              </div>

              <NewsletterSignup />
            </StickyContainer>
          </div>
        </div>
        
      </Container>
      <div className="h-[60rem] w-full absolute bg-soft-red-blue-gradient bottom-0 -z-10 opacity-20" />
    </PageContainer>
  );
};

BlogPage.defaultProps = {};

BlogPage.propTypes = {};

export default BlogPage;
